import { gql } from '@apollo/client';

const queryGetEmployees = gql`
  query EmployeesTableQuery($isActive: Boolean, $position: ID, $project: ID, $term: String) @api(name: admin) {
    employees(isActive: $isActive, position: $position, project: $project, term: $term) {
      user {
        id
        lastName
        firstName
      }
      position {
        id
        title
      }
      assignments(isActive: true) {
        clientContract {
          id
          title
        }
      }
      salary {
        amount
        currency
      }
      vacationDaysLeft
      vacationAutoApproval
      lastRise
      sinceStart
    }
  }
`;

const queryGetPositions = gql`
  query EmployeesPositionsQuery @api(name: root) {
    positions {
      id
      title
    }
  }
`;

const queryGetContracts = gql`
  query EmployeesProjectsQuery($term: String) @api(name: admin) {
    contracts(term: $term) {
      id
      title
    }
  }
`;

export { queryGetEmployees, queryGetPositions, queryGetContracts };
